import { connect } from 'react-redux';

import { Page } from '../../../helbest';
import { _Cart_Clean } from '../../../store/actions/cart_actions';
import { _set_store } from '../../../store/actions/login_actions';
import useChangeStoreLocation from './useChangeStoreLocation';

const ChangeStoreLocation = ({ cartClean, setStore, Login }) => {
  const [
    loading,
    province_list,
    selected_province,
    city_list,
    select_province,
    select_city,
    set_store
  ] = useChangeStoreLocation(cartClean, setStore);

  return (
    <Page
      address="/"
      back={true}
      className="page-change-store-location"
      logo
      showFooter
      title="انتخاب شهر و استان">
      <div className="container desktop-mode">
        <p className="mt-3 font-14 space-between-content mar-b-40">
          <span>شهر و استان فعلی شما: </span>
          <span className="text-green">
            {`${Login.province_name ?? ' ? '} - ${Login.city_name ?? ' ? '}`}
          </span>
        </p>
        <hr />
        <div className="text-center">
          <p className="change-store-label">انتخاب استان</p>
          <select
            className="change-store-select select-round form-control border-red font-14 bg-transparent-05"
            onChange={(e) => select_province(e.target.value)}>
            <option value="" />
            {province_list.map((x, i) => (
              <option key={i} value={x.id}>
                {x.name}
              </option>
            ))}
          </select>

          {selected_province !== '' && !loading ? (
            <>
              <p className="change-store-label">انتخاب شهر</p>
              <select
                className="change-store-select select-round mt-2 form-control border-red font-14 bg-transparent-05"
                onChange={(e) => select_city(e.target.value)}>
                <option value=""> </option>
                {city_list.map((x, i) =>
                  city_list.length === 1 ? (
                    <option key={i} selected value={x.id}>
                      {x.name}
                    </option>
                  ) : (
                    <option key={i} value={x.id}>
                      {x.name}
                    </option>
                  )
                )}
              </select>
            </>
          ) : null}

          <div
            className="button flex-i center-content btn-h48 btn btn-red btn-300 line-none btn-round"
            onClick={() => set_store()}>
            ثبت
          </div>
        </div>
      </div>
    </Page>
  );
};

const mapStateToProps = (state) => ({
  Login: state.Login
});

const mapDispatchToProps = (dispatch) => ({
  cartClean: () => dispatch(_Cart_Clean()),
  setStore: (province_id, city_id, store_id, province_name, city_name) =>
    dispatch(_set_store(province_id, city_id, store_id, province_name, city_name))
});

export default connect(mapStateToProps, mapDispatchToProps)(ChangeStoreLocation);
